import isNumber from 'lodash/isNumber';
import { getQueryStringParams } from 'srcAlias/utils/url';

export default initialState => {
  const { page, segment, segmentName } = getQueryStringParams();

  if (isNumber(segment) || segmentName) {
    return {
      page: page ?? 0,
      segment,
      segmentName,
    };
  }

  return initialState;
};
